import { ApiRayquazaApi } from '@/utils';
import { Municipalities, GenericResponse } from '@/services/generic/types';

export const getTypeDocumentsIdentification = async (): Promise<GenericResponse[]> =>
  (await ApiRayquazaApi.get(`/generic/type-documents-identifications`)).data;
export const getTypeOrganization = async (): Promise<GenericResponse[]> =>
  (await ApiRayquazaApi.get(`/generic/type-organizations`)).data;
export const getMunicipality = async (): Promise<Municipalities[]> =>
  (await ApiRayquazaApi.get(`/generic/municipalities/relations`)).data;
export const getTypeRegime = async (): Promise<GenericResponse[]> =>
  (await ApiRayquazaApi.get(`/generic/type-regimes`)).data;
